
import { useStore } from '@/store'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Footer',
  setup () {
    const { languagePack } = useStore()
    const numOfPast = 2020 - 2006

    return {
      languagePack,
      numOfPast,
      communityMedia: [
        {
          name: 'blogger',
          icon: 'blogger',
          link: 'http://blog.coscup.org/'
        },
        {
          name: 'facebook',
          icon: 'facebook',
          link: 'https://www.facebook.com/coscup/'
        },
        {
          name: 'flickr',
          icon: 'flickr',
          link: 'https://www.flickr.com/photos/coscup/'
        },
        {
          name: 'plurk',
          icon: 'plurk',
          link: 'https://www.plurk.com/coscup'
        },
        {
          name: 'twitter',
          icon: 'twitter',
          link: 'https://twitter.com/coscup'
        },
        {
          name: 'youtube',
          icon: 'youtube',
          link: 'https://www.youtube.com/user/thecoscup'
        },
        {
          name: 'telegram',
          icon: 'telegram',
          link: 'https://t.me/coscupchat'
        },
        {
          name: 'channel',
          icon: 'bullhorn',
          link: 'https://t.me/coscup'
        }
      ]
    }
  }
})
